import { createApp } from "vue";
import App from "./App.vue";
import "@/assets/style/app.scss";
import VueFirework from "vue-firework";

createApp(App)
  .use(VueFirework)
  .mount("#app");
